import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useEffect, useState } from "react";
import * as StorageManager from "../../../utils/StorageManager";
import constants from "../../../constants";
import * as authSelectors from "../../../selectors/auth";
import * as userSelectors from "../../../selectors/user";
import clsx from "clsx";
import MainDeposit from "../../EDeposit/components/MainDeposit";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import PAGE from "../../../utils/Destination";

function DepositGuide({generalData}) {
    const [page, setPage] = useState(1);
    const [token, setToken] = useState(null);
    const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
    const dispatch = useDispatch();
    const userState = useSelector((state) => state.user);
    const clientName = userSelectors.getUserName(userState);
    useEffect(() => {
        setTokenFunction();
    }, [isLogout]);

    async function setTokenFunction() {
        setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
    }

    const onClickDownloadPDF = () => {
        const link = document.createElement('a');
        link.href = '/user-guide-pdf/deposit-guide.pdf';
        link.download = 'deposit-guide.pdf';
        link.click();
    };

    const date = new Date();
    const dateNow = date.toISOString().split("T")[0];
    return (
        <Container fluid className="pb-5">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb styled-breadcrumb">
                    <li className="breadcrumb-item"><a href={PAGE.USER_GUIDE}>User Guide</a></li>
                    <li className="breadcrumb-item"><a className={"text-bold-600"} href={PAGE.DEPOSIT_GUIDE}>e-Deposit</a></li>
                </ol>
            </nav>
            <div className={"primary-border-table-border"} style={{ backgroundColor: "white" }}>
                <div className={clsx("custom-card-label-container text-center d-flex")}>
                    <h2 className={"w-100"}>How do I perform e-Deposit?</h2>
                    <div className={"user-guide-download-content"} onClick={onClickDownloadPDF}>
                        <FontAwesomeIcon
                            icon={faFileArrowDown}
                            className="fa-1x"
                            style={{ marginRight: "10px", color: "white" }}
                        />
                        Download PDF
                    </div>
                </div>
                <br />
                <div>
                    <div className={"user-guide-inner-box gap-1"}>
                        <Image src="/img/userguide/Deposit-1.png"/>
                        <Image src="/img/userguide/Deposit-2.png"/>
                        <Image src="/img/userguide/Deposit-3.png"/>
                    </div>
                    <div className={"user-guide-inner-box gap-1"}>
                        <p>You may then visit Deposit History to proceed View Details or Cancel.</p>
                        <Image src="/img/userguide/Deposit-4.png"/>
                        <Image src="/img/userguide/Deposit-5.png"/>
                        <Image src="/img/userguide/Deposit-6.png"/>
                        <Image src="/img/userguide/Deposit-7.png"/>
                    </div>
                </div>
            </div>

        </Container>
    );
}

export default DepositGuide;
